import React from "react";
import { Box, Dialog, DialogTitle, DialogContent, Button, DialogActions, Card, List, ListItem, ListItemAvatar, Avatar, ListItemText, Typography, Grid, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import TvIcon from '@mui/icons-material/Tv';

function ConfirmDeleteDialog({
  playlists,
  folders,
  screens,
  fileCount = 1,
  onClose,
  onConfirm,
  open,
}) {
  const { t } = useTranslation();
  const hasUsage =
    playlists?.length > 0 || folders?.length > 0 || screens?.length > 0;

  return (
    <>
      <Dialog
        open={open}
        onClose={() => onClose(false)}
        maxWidth={"lg"}
        sx={{
          zIndex: "100000000000",
        }}>
        <Typography variant="caption" mt={3} color="warning.main" textAlign="center">
          {hasUsage
            ? fileCount === 1
              ? 'This file is in use or stored in the locations listed below.'
              : 'These files are in use or stored in the locations listed below.'
            : `No playlist, folder, or screen references the selected ${fileCount === 1 ? 'file' : 'files'}.`}
        </Typography>
        <DialogContent>
          <Box
            sx={{
              width: { xs: "85vw", sm: "70vw", lg: "40vw" },
              maxHeight: "70vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}>

            <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                    <Typography variant="button">Playlists</Typography>
                    <Card variant="outlined">
                        <List sx={{
                            maxHeight: '350px',
                            overflowY: 'scroll'
                        }}>
                            {playlists?.length > 0 ? (
                                playlists.map(p => {
                                    return (
                                        <ListItem key={p._id}>
                                            <ListItemAvatar>
                                                <Avatar>
                                                    <SubscriptionsIcon />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText primary={`${p.playlistName.slice(0, 20)}${p.playlistName.length > 20 ? '...' : ''}`}/>
                                        </ListItem>
                                    )
                                })
                            ) : (
                                <Typography p={2}>
                                  No playlist contains {fileCount === 1 ? 'this file' : 'these files'}
                                </Typography>
                            )}
                        </List>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography variant="button">Folders</Typography>
                    <Card variant="outlined">
                        <List sx={{
                            maxHeight: '350px',
                            overflowY: 'scroll'
                        }}>
                            {folders?.length > 0 ? (
                                folders.map(f => {
                                    return (
                                        <ListItem key={f.id}>
                                            <ListItemAvatar>
                                                <Avatar>
                                                    <FolderOpenOutlinedIcon />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText primary={`${f.name.slice(0, 20)}${f.name.length > 20 ? '...' : ''}`}/>
                                        </ListItem>
                                    )
                                })
                            ) : (
                                <Typography p={2}>
                                  No folder contains {fileCount === 1 ? 'this file' : 'these files'}
                                </Typography>
                            )}
                        </List>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography variant="button">Screens</Typography>
                    <Card variant="outlined">
                        <List sx={{
                            maxHeight: '350px',
                            overflowY: 'scroll'
                        }}>
                            {screens?.length > 0 ? (
                                screens.map(screen => (
                                    <ListItem key={screen._id}>
                                        <ListItemAvatar>
                                            <Avatar>
                                                <TvIcon />
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText primary={screen.deviceName || screen.screenCode || screen._id} />
                                    </ListItem>
                                ))
                            ) : (
                                <Typography p={2}>
                                  No screen uses {fileCount === 1 ? 'this file' : 'these files'} as an object
                                </Typography>
                            )}
                        </List>
                    </Card>
                </Grid>
            </Grid>

            <DialogTitle sx={{ textAlign: "center" }} my={3}>
              Are you sure to delete {fileCount === 1 ? 'the file' : `${fileCount} files`}?
            </DialogTitle>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px 10px",
              }}>
              <Button
                variant={"outlined"}
                sx={{
                  height: "38px",
                  width: "193px",
                  textTransform: "capitalize",
                  borderRadius: "5px",
                }}
                onClick={onClose}>
                {t("components.confirmationModel.no")}
              </Button>
                <Button
                    variant={"contained"}
                    onClick={onConfirm}
                    sx={{
                    height: "38px",
                    width: "193px",
                    textTransform: "capitalize",
                    borderRadius: "5px",
                    }}>
                    {t("components.confirmationModel.yes")}
                </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default ConfirmDeleteDialog;
